
<script>

import listpage from '../listpage';
import type_selector from './type_selector';
import { mapActions } from 'vuex';

export default {
    name: 'log-listpage',
    extends: listpage,
    components: { 'type-selector': type_selector },
    props: [],
    computed: {
        params() { return this.store.params; },
    },
    watch: {
    },
    methods: {
        ...mapActions( 'log', { set_params_order: 'set_params', add_filter: 'add_filter', remove_filter: 'remove_filter', force_reload: 'force_reload' } ),
        set_filters( new_value ) {
            if ( new_value === null ) { this.remove_filter( 'type__in' ); }
            else { this.add_filter( { type__in: new_value } ); }
            this.force_reload();
            this.list_key += 1;
        },
        toggle_modal(modal_id = 'modal-filter') {
            this.$root.$emit('bv::toggle::modal', modal_id);
        },
        clear_search_form( modal_event ) {
            if ( modal_event.trigger === 'clear' ) {
                Object.keys( this.filters ).map( x => {
                    this.remove_filter( x );
                    delete this.filters[ x ];
                });
                this.force_reload();
                this.list_key += 1;
                this.toggle_modal();
            }
        },
        operation_success( data ) {
            Object.keys( data ).map( x => {
                if ( data[ x ] === null || data[ x ] === '' ) {
                    this.remove_filter( x );
                    delete this.filters[ x ];
                } else {
                    if ( [ 'controller', 'action' ].includes( x ) ) {
                        this.add_filter( { [ x ]: '|' + String( data[ x ] ) + '|' } );
                    } else if ( x === 'tags' ) {
                        this.add_filter( { [ x ]: '[' + String( data[ x ] ) + ']' } );
                    } else {
                        this.add_filter( { [ x ]: data[ x ] } );
                    }
                    this.filters[ x ] = data[ x ];
                }
            });
            this.force_reload();
            this.list_key += 1;
            this.toggle_modal();
        },
        submit_search_form() {
            this.$refs.search_form.submit_form();
        },
        value_changed( /*payload*/ ) {
        },
    },
    created() {
        if ( this.params.hasOwnProperty('type__in') ) { this.type__in = this.params.type__in; }
        if ( this.params.hasOwnProperty('created__gte') ) { this.filters.created__gte = this.params.created__gte; }
        if ( this.params.hasOwnProperty('created__lte') ) { this.filters.created__lte = this.params.created__lte; }
        if ( this.params.hasOwnProperty('controller') ) { this.filters.controller = this.params.controller.replace(/\|/g, ''); }
        if ( this.params.hasOwnProperty('action') ) { this.filters.action = this.params.action.replace(/\|/g, ''); }
        if ( this.params.hasOwnProperty('user_id') ) { this.filters.user_id = this.params.user_id; }
        if ( this.params.hasOwnProperty('customer_id') ) { this.filters.customer_id = this.params.customer_id; }
        if ( this.params.hasOwnProperty('tags') ) { this.filters.tags = this.params.tags.replace( '[', '' ).replace( ']', '' ); }
    },
    data() {
        return {
            filters          : {},
            list_key         : 0,
            modal_filter_key : 0,
            type__in         : null,
            search_schema    : '_search_log',
        };
    }
}

</script>

<template>

    <div style="width: 80%; margin: auto">
        <b-row>
            <b-col>
                <b-button variant="outline-success" @click="toggle_modal()" size="sm"><icon name="filter" style="color: #DC3545;" color="#DC3545" id="filter-icon"/></b-button>
            </b-col>
            <b-col>
                <h2 v-if="options.title_list" style="text-align: center; margin-bottom: 30px">{{ options.title_list.toUpperCase() }}</h2>
            </b-col>
            <b-col class="text-right">
                <type-selector
                    :value  = "type__in"
                    @update = "set_filters"
                />
            </b-col>
        </b-row>
        <vmm-list
            ref              = "listbnv"
            :model           = "model"
            :options         = "override_options"
            :key             = "list_key"

            :skip            = "false"
            :destroy         = "destroy"

            @row_selected    = "row_selected"
            @right-click     = "right_click"
        />

        <!-- modal filtri -->
        <b-modal
            id="modal-filter"
            title="Filtri"
            @hide="clear_search_form"
            button-size="sm"
            >
            <vmm-form
                v-if       = "search_schema"
                :key       = "modal_filter_key"
                :name      = "search_schema"
                :schema    = "$models._search_log"
                :options   = "{}"
                :record    = "filters"
                :submit    = "false"
                :inline    = "true"
                ref        = "search_form"
                @submitted = "operation_success"
                @change    = "value_changed"
            ></vmm-form>
            <template v-slot:modal-footer="{ ok, cancel, hide }">
                <b-row><b-col>
                    <b-button size="sm" variant="success" @click="submit_search_form">
                      OK
                    </b-button>
                </b-col><b-col>
                    <b-button size="sm" variant="warning" @click="hide('clear')">
                      Reset
                    </b-button>
                </b-col><b-col>
                    <b-button size="sm" variant="outline-secondary" @click="cancel()">
                      Chiudi
                    </b-button>
                </b-col></b-row>
            </template>
        </b-modal>
    </div>

</template>

